module.exports = __webpack_public_path__ + "img/185-haiti.64c05f52.svg";